import React from 'react';
import { formatSizeUnits } from '../../utils/utils';
import PropTypes from 'prop-types';

import { Icon } from 'ui';

const AttachEntry = ({ guid, name, size, onRemove }) => {
  return (
    <div className="upload-attach__entry">
      <div className="upload-attach__entry-left">
        <div className="upload-attach__entry-name">{name}</div>
        <div className="upload-attach__entry-size">{formatSizeUnits(size)}</div>
      </div>
      <div className="upload-attach__entry-right">
        <div className="upload-attach__entry-remove" onClick={() => onRemove(guid)}>
          <Icon name="close" />
        </div>
      </div>
    </div>
  );
};

AttachEntry.propTypes = {};

AttachEntry.defaultProps = {
  guid: '1',
  name: 'test',
  size: 100,
  onRemove: () => {},
};

export default AttachEntry;
